import inject from './inject';
import PropertiesTab from './PropertiesTab';

// @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
export default inject(PropertiesTab);
